export const baseURL = "https://classicteenpatti.zelvio.fun/";
export const adminBaseURL = "https://admin.zelvio.fun/";
export const key = "princeflutterdev@Resend.devrJCEgMD7vBXazecF7vvVe3rqBwxmwRM6jHLGcaBB97o=";
